import { types } from 'mobx-state-tree'
import Expression from '../Expression'
import { SliderTemplate } from '../Template'
import { Fill, Layerable, Rectangle, Stroke, Transformable, Visible, UI, LimitedStateful as Stateful } from './shared/props'
import assetViews from './shared/views'
import assetChildTypes from './shared/childTypes'

const AssetType = 'Slider'

const model = types
  .model(AssetType, {
    // Entity
    Type: types.literal(AssetType),
    objectId: types.identifier,
    // Asset
    name: types.string,
    children: types.late(assetChildTypes),
    min: types.number,
    max: types.number,
    step: types.number,
    value: Expression,
    disabled: Expression,
    template: types.maybeNull(types.reference(SliderTemplate)),
    ...Layerable,
    ...Fill,
    ...Stroke,
    ...Rectangle,
    ...Visible,
    ...Transformable,
    ...UI,
    ...Stateful
  })
  .views(assetViews)

export default model
